import http from '@root/utils/axios/admin';

let state = {
    RamsList: [],
    Ram: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchRamsList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('user/rams', { params: filter }).then((response) => {
                commit('setRamsList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteRam({ commit }, id) {
        return http.delete('user/rams/' + id);
    },

    fetchRam({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('user/rams/' + id).then((response) => {
                commit('setRam', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateRam({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/rams', data).then((response) => {
                commit('setRam', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setRamError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateRam({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/rams/' + data.id, data).then((response) => {
                commit('setRam', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setRamError', error.response.data);
                }
                reject(error.response);
            })
        });
    },



}


let mutations = {
    setRamsList(state, data) {
        state.RamsList = data;
    },
    setRam(state, data) {
        state.Ram.data = data;
    },
    setRamError(state, error) {

        state.Ram.error = error.errors;
    },
    cleanRamError(state, error) {
        state.Ram.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}